import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./components/home";
import SelectSupermarketPage from "./components/selection";
import ShoppingListPage from "./components/shopping-list";
import ResultsPage from "./components/ResultsPage";

function App() {
  return (
    <Router> {/* Remove any basename - not needed for custom domain */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/select-supermarket" element={<SelectSupermarketPage />} />
        <Route path="/shopping-list" element={<ShoppingListPage />} />
        <Route path="/results" element={<ResultsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
